import $ from 'jquery';

import Vars from '../../vars'

import Action from '../classes/Action';
import Dropzone from '../classes/Dropzone';
import Validation from '../classes/Validation';

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

import DropzoneComplex from '../dropzone/complex';

import Progress from './Progress';
import Building from "./Building"
import Company from "./Company";

class Complex {
    constructor (args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content : $(),
        $create  : $(),
        $edit    : $(),
        $modal   : $(),
        $form    : $(),
        $sort    : $()
    };

    _state = {
        progress : {},
        args     : {},
        breadcrumbs : {},
        itemId   : 0,
        item     : {},
        items    : {},
        fields   : {},
        dropzone : {
            items : {}
        },
        tariff   : {}
    };

    _const = {
        entities : 'objects',
        entity   : 'object',
        title : {
            add  : 'Добавление нового комплекса',
            edit : 'Редактирование комплекса'
        }
    };
    
    _args = {
        id       : 0,
        mode     : '',
        done     : function(){}
    };

    _utils = {
        validation : {}
    };

    _actions = {
        activate : {
            title: 'Активация жилого комлекса',
            content : function(args){
                let self = args.self;
                if (!self) return;

                return Utils.renderProfileTemplate(self._const.entity + '-activate-confirmation', {
                    [self._const.entity] : self._args.mode === Vars.view.list ? self._state.items.filter(function(item){ return item.id == args.id })[0] : self._state.item,
                    tariff               : self._state.tariff
                })
            },
            building : {
                title        : 'Активация дома',
                entities     : 'buildings',
                confirmation : {
                    title : 'этот дом'
                },
                content  : function(args){
                    let self = args.self;
                    if (!self) return;

                    return Utils.renderProfileTemplate( 'building-activate-confirmation', {
                        building : self._state.item.buildings.filter(function(building){ return building.id == args.id; })[0]
                    })
                }
            }
        },
        deactivate : {
            title: 'Деактивация жилого комлекса',
            building : {
                title : 'Деактивация дома',
                entities     : 'buildings',
                confirmation : {
                    title : 'этот дом'
                }
            }
        },
        remove : {
            title    : 'Удаление жилого комлекса',
            building : {
                title : 'Удаление дома',
                entities     : 'buildings',
                confirmation : {
                    title : 'этот дом'
                }
            }
        },
        confirmation : {
            title: 'этот жилой комлекс'
        },
        done : {
            activate : function(args) {
                let self = args.self;

                if (self._args.mode === Vars.view.list) {
                    self._list();
                }
                else if (self._args.mode === Vars.view.item) {
                    if (args[self._const.entity]) {
                        self._state.item = args[self._const.entity];
                    }
                    else {
                        self._item();
                        return;
                    }

                    let dropdown = Utils.renderProfileTemplate(self._const.entity + '-dropdown', {
                        object : self._state.item,
                        tariff : self._state.tariff
                    });

                    self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                        crumbs : [
                            {
                                title : 'Жилые комплексы',
                                href  : '#objects'
                            },
                            {
                                title : self._state.item.name
                            }
                        ],
                        dropdown : dropdown,
                        activate : {
                            id        : self._state.item.id,
                            is_active : self._state.item.is_active
                        }
                    });

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                        breadcrumbs          : self._state.breadcrumbs,
                        [self._const.entity] : self._state.item,
                        tariff               : self._state.tariff
                    }));

                    self._bindElements();
                    self._bindUI();

                    $('.aside').trigger('update');

                    new Building({
                        mode     : Vars.view.object,
                        object   : self._state.item,
                        objectId : self._state.item.id
                    });
                }
            },
            deactivate : function(args) {
                let self = args.self;

                if (self._args.mode === Vars.view.list) {
                    self._list();
                }
                else if (self._args.mode === Vars.view.item) {
                    if (args[self._const.entity]) {
                        self._state.item = args[self._const.entity];
                    }
                    else {
                        self._item();
                        return;
                    }

                    let dropdown = Utils.renderProfileTemplate(self._const.entity + '-dropdown', {
                        object : self._state.item,
                        tariff : self._state.tariff
                    });

                    self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                        crumbs : [
                            {
                                title : 'Жилые комплексы',
                                href  : '#objects'
                            },
                            {
                                title : self._state.item.name
                            }
                        ],
                        dropdown : dropdown,
                        activate : {
                            id        : self._state.item.id,
                            is_active : self._state.item.is_active
                        }
                    });

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                        breadcrumbs          : self._state.breadcrumbs,
                        [self._const.entity] : self._state.item,
                        tariff               : self._state.tariff
                    }));

                    self._bindElements();
                    self._bindUI();

                    $('.aside').trigger('update');

                    new Building({
                        mode     : Vars.view.object,
                        object   : self._state.item,
                        objectId : self._state.item.id
                    });
                }
            },
            remove : function(args) {
                let self = args.self;
                if (self._args.mode == Vars.page.list) {
                    self._list();
                    $('.aside').trigger('update');
                }
                else if (args.name == 'building') {
                    window.location.reload();
                }
            }
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.id      = args.id || 0;
        self._args.mode    = args.mode;
        self._args.done    = args.done;
        self._args.title   = args.title;
    };

    _setFields = () => {
        let self = this;

        self._state.fields = {};
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _setDropzone = () => {
        let self = this;

        self._state.dropzone.items = DropzoneComplex.get({
            item     : self._state.item,
            entities : self._const.entities
        });
        self._state.dropzone.entity = self._state.item;
    };

    _initModal = (args) => {
        let self = this;

        self._setFields();
        self._setDropzone();

        self._elems.$modal = new Modal({
            title : Object.keys(self._state.item).length ? self._const.title.edit : self._const.title.add,
            closingConfirmation : true,
            content: Utils.renderProfileTemplate(self._const.entity + '-form', {
                [self._const.entity] : Object.keys(self._state.item).length ? self._state.item : null,
                options              : args,
                entity               : self._const.entity,
                fields               : self._state.fields
            }),
            dropzone : self._state.dropzone,
            confirm  : function(args) {
                self._bindSubmit(args);
            },
            closing : function(args) {
                if (self._args.mode == Vars.page.list) {
                    self._state.item = {}
                }
            }
        });

        self._elems.$form = self._elems.$modal.find('form');

        self._elems.$form.find('input, select').eq(0).focus();

        self._bindForm();
        self._bindCompanies({
            companies : args.companies
        });
    };

    _bindForm = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._setValidation();
        self._updatePreview();
        self._bindNames();

        self._elems.$form.find('select[name="object[type]"]').change(function() {
            self._updatePreview();
        });
        self._elems.$form.find('input[name="object[name]"]').keyup(function() {
            self._updatePreview();
        });

        self._elems.$form.find('input[name="object[video_link]"]').change(function() {
            $(this).parents('.form-field').removeClass('error');
            $(this).parent().next('.form-field__message').empty();
        });
        self._elems.$form.find('input[name="object[video_link]"]').keyup(function() {
            $(this).parents('.form-field').removeClass('error');
            $(this).parent().next('.form-field__message').empty();
        });
    };

    _updatePreview = () => {
        let self  = this;

        if (!self._elems.$form.length) return;

        const objectType = self._elems.$form.find('select[name="object[type]"]').val();
        const name       = self._elems.$form.find('input[name="object[name]"]').val();

        if (objectType && name) {
            self._elems.$form.find('.form-text-preview').text(ifacade.constants.objects.types[objectType].short_name + ' "' + name + '"').slideDown();
        } else {
            self._elems.$form.find('.form-text-preview').text('---').slideUp();
        }
    };
    
    _updateForm = (countOfAlternativeNames) => {
        let self  = this;

        if (!self._elems.$form.length) return;

        if (countOfAlternativeNames === 0) {
            self._elems.$form.find('.form-group[data-name="alternative_names"] .form-group__link.remove').hide();
        }
        else {
            self._elems.$form.find('.form-group[data-name="alternative_names"] .form-group__link.remove').show();
        }

        if (countOfAlternativeNames >= 5) {
            self._elems.$form.find('.form-group[data-name="alternative_names"] .form-group__link.add').hide();
        }
        else {
            self._elems.$form.find('.form-group[data-name="alternative_names"] .form-group__link.add').show();
        }

        self._elems.$form.find('.form-group[data-name="alternative_names"] .form-group__section').slice(0, countOfAlternativeNames).show();

        self._elems.$form.find('.form-group[data-name="alternative_names"] .form-group__section').slice(countOfAlternativeNames).each(function() {
            $(this).find('input').val('');
        }).hide();
    };

    _bindElements = () => {
        let self = this;
        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$create = self._elems.$content.find('.js-profile-object-create');
        self._elems.$edit   = self._elems.$content.find('.js-profile-object-edit');
        self._elems.$sort   = self._elems.$content.find('.js-profile-building-sort');
    };

    _bindProgress = () => {
        let self = this;
        self._state.progress = new Progress();
    };

    _bindActions = () => {
        let self = this;

        if (self._args.mode === Vars.view.index) return;

        new Action({
            id       : self._state.item.id,
            actions  : self._actions,
            entities : self._const.entities,
            entity   : self._const.entity,
            self     : self
        });
    };

    _bindNames = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        let countOfAlternativeNames = Object.keys(self._state.item).length ? self._state.item.alternative_names.reduce(function (count, alternative_name, alternative_name_index) {
            return (alternative_name ? alternative_name_index + 1 : count);
        }, 0) : 0;

        self._elems.$form.find('.form-group[data-name="alternative_names"] .form-group__link.add').click(function (e) {
            e.preventDefault();
            ++countOfAlternativeNames;
            self._updateForm(countOfAlternativeNames);
        });

        self._elems.$form.find('.form-group[data-name="alternative_names"] .input__remove').click(function (e) {
            e.preventDefault();
            let $form_group__section = $(this).closest('.form-group__section');
            if (!$form_group__section.length) return;

            let alternativeNames = [];

            self._elems.$form.find('[data-name^="alternative_name"] input').each(function(){
                alternativeNames.push($(this).val());
            });

            alternativeNames.splice($form_group__section.index(), 1);
            alternativeNames.forEach(function (alternative_name, index) {
                self._elems.$form.find('input[name="object[alternative_name' + index + ']"]').val(alternative_name);
            });

            --countOfAlternativeNames;
            self._updateForm(countOfAlternativeNames);
        });

        self._updateForm(countOfAlternativeNames);
    };

    _bindCompanies = (args) => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._elems.$form.find('.form-group__link.add.is-create-new-company').click(function (e) {
            e.preventDefault();

            new Company({
                mode  : Vars.view.object,
                items : args.companies,
                done  : function(company){
                    args.companies.push(company);
                    [
                        'distributor_id'
                    ].forEach(function (property_name) {
                        let $select = self._elems.$form.find('select[name="object[' + property_name + ']"]');
                        $('<option />').text(ifacade.constants.companies.organizational_forms[company.organizational_form].short_name + ' "' + company.name + '"').val(company.id).appendTo($select);
                        $select.val(company.id);
                    });

                    new Modal({
                        title   : 'Создание компании',
                        content : Utils.renderProfileTemplate('info', {
                            message : 'Новая компания успешно создана. Теперь вы можете выбрать её в соответствующем списке.',
                            buttons : {
                                one : {
                                    class : 'confirm button--edit',
                                    title : 'Продолжить'
                                },
                                two : null
                            }
                        })
                    });
                }
            });
        });
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        const errors = $form.find('.form-field.error').length;

        if(errors) return;

        loader.increase();

        const action = Object.keys(self._state.item).length ? self._state.item.id + '/edit' : 'create';

        Request.send({
            path   : '/api/' + self._const.entities + '/' + action,
            method : 'POST',
            data   : $form.serialize(),

            done: function(response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return
                }

                $modal.trigger('close');

                if (self._args.mode == Vars.page.list && action == 'create') {
                    window.location.href = '/profile#' + self._const.entities + '/' + response[self._const.entity].id;
                }
                else if (self._args.mode == Vars.page.list) {
                    self._list();
                }
                else {
                    self._state.item  = response[self._const.entity];
                    self._state.items = {};

                    if(self._args.mode === Vars.view.index || self._args.mode === Vars.view.list) {
                        window.location.href = '/profile#' + self._const.entities + '/' + self._state.item.id;
                    }
                }
            }
        });
    };

    _bindUI = () => {
        let self = this;

        self._elems.$create.length && self._elems.$create.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();
            Request.send({
                path: '/api/options?only=companies',
                done: function(response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    let args  = response.options ? response.options : [];

                    self._initModal(args);
                }
            });
        });

        self._elems.$edit.length && self._elems.$edit.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();

            const id = self._args.mode === Vars.page.list ? $(this).data('id') : self._state.item.id;

            Request.send({
                queue: [
                    {
                        path: '/api/' + self._const.entities + '/' + id
                    },
                    {
                        path: '/api/options?only=companies'
                    }
                ],
                done: function(response, extraResponse) {
                    loader.decrease();
                    Utils.scrollToTop();

                    if (self._args.mode == Vars.page.list) {
                        self._state.item  = response[self._const.entity];
                        let options       = extraResponse.options ? extraResponse.options : [];
                        self._initModal(options);
                    }
                    else if (Object.keys(self._state.item).length) {
                        self._state.items = {};
                        self._state.item  = response[self._const.entity];
                        let options       = extraResponse.options ? extraResponse.options : [];
                        self._initModal(options);
                    }
                    else {
                        window.location.href = '/profile#' + self._const.entities;
                    }
                }
            });
        });

        self._elems.$sort.length && self._elems.$sort.unbind('click').on('click', function(e) {
            e.preventDefault();

            let $parent = $(this).parent();
            const id = $(this).data('building_id');
            const action = $(this).data('action');

            loader.increase();

            Request.send({
                path: '/api/' + self._const.entities + '/' + self._state.item.id + '/buildings/' + id + '/sort/' + action,
                done: function(response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    const object = response.object;

                    for(let key in self._state.item.buildings) {
                        object.buildings.forEach(function(building){
                            if (self._state.item.buildings[key].id == building.id) {
                                self._state.item.buildings[key].number = building.number;
                            }
                        });
                    }

                    let dropdown = Utils.renderProfileTemplate(self._const.entity + '-dropdown', {
                        object : self._state.item,
                        tariff : self._state.tariff
                    });

                    self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                        crumbs : [
                            {
                                title : 'Жилые комплексы',
                                href  : '#objects'
                            },
                            {
                                title : self._state.item.name
                            }
                        ],
                        dropdown : dropdown,
                        activate : {
                            id        : self._state.item.id,
                            is_active : self._state.item.is_active
                        }
                    });

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                        breadcrumbs          : self._state.breadcrumbs,
                        [self._const.entity] : self._state.item,
                        tariff               : self._state.tariff
                    }));

                    self._bindElements();
                    self._bindUI();

                    new Building({
                        mode     : Vars.view.object,
                        object   : self._state.item,
                        objectId : self._state.item.id
                    });
                }
            });
        });

        self._bindActions();

        if (Object.keys(self._state.progress).length) {
            self._state.progress.update({
                [self._const.entity] : self._state.item
            });
        }
    };

    _index  = () => {
        let self = this;
        self._bindUI();
    };

    _list = () => {
        let self = this;

        Request.send({
            path : '/api/' + self._const.entities,
            done : function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items = response[self._const.entities];
                self._state.item  = {};

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs            : self._state.breadcrumbs,
                    [self._const.entities] : self._state.items
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _item = () => {
        let self = this;

        Request.send({
            path : '/api/' + self._const.entities + '/' + self._args.id,
            data : {
                info: 'short'
            },
            done : function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item  = response[self._const.entity];
                self._state.items = {};
                self._state.tariff = response.tariff;

                let dropdown = Utils.renderProfileTemplate(self._const.entity + '-dropdown', {
                    object : self._state.item,
                    tariff : self._state.tariff
                });

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Жилые комплексы',
                            href  : '#objects'
                        },
                        {
                            title : self._state.item.name
                        }
                    ],
                    dropdown : dropdown,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item,
                    tariff               : self._state.tariff
                }));

                self._bindElements();
                self._bindProgress();
                self._bindUI();

                new Building({
                    mode     : Vars.view.object,
                    object   : self._state.item,
                    objectId : self._state.item.id
                });
            }
        });
    };

    _import = () => {
        let self = this;

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._args.id,
            data: {
                info: 'for_import'
            },
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item  = response[self._const.entity];
                self._state.items = {};

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Жилые комплексы',
                            href  : '#objects'
                        },
                        {
                            title : self._state.item.name,
                            href  : '#objects/' + self._state.item.id
                        },
                        {
                            title : 'Импорт предложений из XLS'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-import', {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item,
                    tariff               : self._state.tariff
                }));

                self._elems.$form = self._elems.$content.find('#import-form');
                self._setDropzone();

                let $dropzone = self._elems.$content.find('.dropzone');
                if (!$dropzone.length) return;

                new Dropzone({
                    root   : $dropzone,
                    form   : self._elems.$form,
                    items  : self._state.dropzone.items,
                    entity : self._const.entities
                });

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;

        self._bindElements();

        if (self._args.mode === Vars.view.index) {
            self._index();
        } else if (self._args.mode === Vars.view.list) {
            self._list();
        } else if (self._args.mode === Vars.view.item) {
            self._item();
        } else if (self._args.mode === Vars.view.import) {
            self._import();
        }
    };
}

export default Complex;